import { useEffect } from "react";

export const useEscape = (callback?: () => void) => {
    const onEscape = (event: KeyboardEvent) => {
        if (event.key == "Escape") {
            event.preventDefault();
            event.stopPropagation();
            callback?.();
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', onEscape);

        return () => document.removeEventListener('keydown', onEscape);
        //eslint-disable-next-line
    }, []);
}